export default {
  SheetName: {
    StructureByWorkType: 'Cơ cấu công việc',
    StateByWorkType: 'Tình trạng công việc',
    CompareStateExecuteWork: 'So sánh tình hình thực hiện',
  },
  Title: {
    StateByWorkType: 'Tình trạng công việc theo loại việc',
    StructureByWorkType: 'Cơ cấu công việc theo loại việc',
    UseState: 'Tình hình sử dụng',
    WorkTypeOverviewByRole: 'Cơ cấu loại việc theo vai trò',
    WorkStateOverviewByRoleAndWorkType: 'Tình hình công việc',
    StateExecuteWork: 'Tình hình thực hiện công việc',
    CompareStateExecuteWork: 'So sánh tình hình thực hiện công việc',
    WorkStateOverviewByRoleAndWorkType: 'Tình trạng công việc theo vai trò - loại việc',
    StatisticsByWorkType: "Thống kê công việc theo loại việc",
    ReportWorkStateOverviewByExecutor: 'Tình trạng công việc tôi chủ trì',
    ReportWorkStateOverviewByAssigner: 'Tình trạng công việc tôi đã giao',
    ReportWorkStateOverviewByCombination: 'Tình trạng công việc tôi phối hợp',
    ReportWorkStateOverviewBySupervisor: 'Tình trạng công việc tôi phụ trách',
    ReportAssignedTaskNeedApprove: 'Công việc chỉ đạo cần thực hiện',
    ReportSupervisorTaskNeedApprove: 'Công việc phụ trách cần thực hiện',
    ReportExecutorTaskNeedProcess: 'Công việc chủ trì cần thực hiện',
    WorkStateOverview: 'Tổng quan tình trạng công việc',
    WorkStateToEvaluate:'Đánh giá tình hình thực hiện công việc'
  },
  ExportFileName: {
    StateExecuteWork: 'Tinh_hinh_thuc_hien_cong_viec.xlsx',
    WorkStateToEvaluate: 'Danh_gia_tinh_hinh_thuc_hien_cong_viec.xlsx',
    CompareStateExecuteWork: 'So_sanh_tinh_hinh_thuc_hien_cong_viec.xlsx',
  },
  AuthorizationWork: {
    Title: 'Tôi được ủy quyền',
    CreateUserName: 'Người ủy quyền',
    Created: 'Ủy quyền từ ngày',
    NeedWork: 'Công việc cần thực hiện',
    NeedApproval: 'Cần phê duyệt',
    NeedExecutor: 'Cần chủ trì',
    NeedCombination: 'Cần phối hợp',
  },
  EmptyData: 'Không có dữ liệu hiển thị',
  OwnerOrganizationUnit : 'Đơn vị chủ quản:',
  TimeRemind: 'Thời hạn nhắc việc:',
  TimeRemindTitle: 'Thời hạn nhắc việc',
  OrderBy: 'Sắp xếp theo:',
  SortDirection : 'Hướng sắp xếp:',
  NumberOfSuccessInTimeTasks: 'Hoàn thành',
  NumberOfSuccessOutTimeTasks: 'Hoàn thành trễ hạn',
  NumberOfInProcessInTimeTasks: 'Chưa hoàn thành',
  NumberOfInProcessOutTimeTasks: 'Chưa hoàn thành trễ hạn',
  NumberOfNotSuccessTasks: 'Không hoàn thành',
  NumberOfSuccessOutTimeTasks2: 'Hoàn thành trễ hạn',
  PersonalityAndOrg: 'Cá nhân/Đơn vị',
  FullName: 'Họ và tên',
  FirstTerm: 'Kỳ 1',
  SecondTerm: 'Kỳ 2',
  CompareTo: 'so với',
  OrganizationUnit: 'Đơn vị',
  OrganizationUnit2: 'Đơn vị: ',
  FullNameLabel: 'Họ và tên',
  ChartList: 'Danh sách biểu đồ',
  NoChartToChoose: 'Đã hết biểu đồ để chọn',
  UseAllAddableCharts: 'Bạn đã sử dụng hết các biểu đồ được cung cấp',
  TaskName: 'Tên công việc',
  Deadline: 'Hạn hoàn thành',
  Status: 'Tình trạng',
  Remind: 'Nhắc hạn',
  TaskList: 'Danh sách công việc',
  WorkState: 'Tình trạng công việc',
  EditChart: 'Tùy chỉnh biểu đồ',
  AddChart: 'Thêm biểu đồ',
  ConfirmSaveChangeChartList: 'Tùy chỉnh đã thay đổi. Bạn có muốn lưu lại không?',
  NoChartToDisplay: 'Bạn đang không hiển thị biểu đồ nào',
  ConfigChartGuide: 'Bấm vào đây để tùy chỉnh biểu đồ thống kê muốn theo dõi',
};
